module.exports = __webpack_public_path__ + "media/chapter_5.fba17ad1.mp4";